import "./Hamburger.css";

export default function Hamburger() {
    
    return (
        <div className="hamburger">
            <div className="menu icon"></div>
        </div>
    );
}